import {GetWalletResponse_PausedModal} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/wallet/v1/page/service.types';
import {
  COLORS,
  ContentPopper,
  Flyout,
  GenericIconName,
  Icon,
  ModalDialog,
  ModalDialogContent,
  SecondaryContentPopperButton,
  Text,
  Z_INDEXES,
} from '@aboutyou/ui-components';
import {styled} from '@linaria/react';
import React, {useRef, useState} from 'react';
import {useOpenCoinsClaimPopup} from '../../features/Coins/CoinsWallet/ClaimedCoins/useOpenCoinsClaimPopup';
import {WalletType} from './utils/useActiveTab';
import {NormalizedWalletTab} from './utils/useNormalizeTabs';

export const ConditionalWalletPauseState: React.FC<{
  activeTab: WalletType;
  tabs: NormalizedWalletTab[];
}> = ({activeTab, tabs}) => {
  const {isOpen: isCoinsClaimPopupOpen} = useOpenCoinsClaimPopup();
  const currentTab = tabs.find(tab => tab.value === activeTab);
  const wasWalletPauseStateDisplayed = useRef(false);

  const onWalletPauseStateClose = () => {
    wasWalletPauseStateDisplayed.current = true;
  };

  if (
    currentTab?.pausedModal &&
    !wasWalletPauseStateDisplayed.current &&
    !isCoinsClaimPopupOpen
  ) {
    return (
      <WalletPauseState
        {...currentTab.pausedModal}
        activeTab={activeTab}
        onClose={onWalletPauseStateClose}
      />
    );
  }

  return null;
};

export const WalletPauseState: React.FC<
  GetWalletResponse_PausedModal & {activeTab: WalletType; onClose: VoidFunction}
> = ({title, subtitle, ctaLabel, activeTab, onClose}) => {
  const [isOpen, setIsOpen] = useState(true);

  const closePauseState = () => {
    setIsOpen(false);
    onClose();
  };

  return (
    <StyledContentPopper
      data-testid="walletPauseState"
      renderInPortal
      LayoutComponent={process.env.STACK === 'desktop' ? ModalDialog : Flyout}
      open={isOpen}
      onClose={closePauseState}
      bodyContent={
        <Wrapper>
          <PauseIcon
            $fill={activeTab === 'coins' ? 'Fill.Black' : 'Coupon.Primary'}
          >
            <Icon asset={GenericIconName.PauseRound} size="S" fill="White" />
          </PauseIcon>
          <Text
            size="px24"
            weight="heavy"
            color={activeTab === 'coins' ? 'Text.Black' : 'Coupon.Primary'}
          >
            {title}
          </Text>
          <Text weight="mediumBold">{subtitle}</Text>
        </Wrapper>
      }
      footerContent={
        <SecondaryContentPopperButton
          data-testid="walletPauseStateCloseButton"
          label={ctaLabel}
          onClick={closePauseState}
        />
      }
    />
  );
};

const StyledContentPopper = styled(ContentPopper)`
  width: 100%;
  padding: 0;
  z-index: ${Z_INDEXES.FLYOUT_FADE_ON_DRAWER};

  ${ModalDialogContent} {
    max-width: 375px;
    border-radius: 16px;
  }
`;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  text-align: center;
  padding: 32px 48px;
`;

const PauseIcon = styled.div<{$fill: keyof typeof COLORS}>`
  display: flex;
  justify-content: center;
  align-items: center;
  background: ${({$fill}) => COLORS[$fill]};
  width: 48px;
  height: 48px;
  border-radius: 100%;
`;
